module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel02_770_280_ko-7ab5b0188c20af306420e1ac8e8d652f.jpg";